import type { SxProps } from '@mui/material';

import type { DebounceInputProps } from '../DebounceInput';
import type { InputProps } from 'shared/components/Input';

import { Root, StyledInput, StyledSearchIcon } from './Search.styled';

type SearchProps<Debounce extends boolean | undefined> = {
  debounce?: Debounce;
  rootSx?: SxProps;
} & (Debounce extends true ? DebounceInputProps : InputProps);

const Search = <Debounce extends boolean | undefined>({
  debounce,
  rootSx,
  ...rest
}: SearchProps<Debounce>) => (
  <Root sx={rootSx}>
    <StyledInput debounce={debounce} {...rest} />
    <StyledSearchIcon />
  </Root>
);

export default Search;
